import { Row, Col, Select, Typography } from "antd";
import React from "react";

const { Option } = Select;
const { Text } = Typography;

interface DropdownSectionProps {
  label: string;
  value: any;
  options: string[];
  placeholder?: string;
  onChange: (value: any) => void;
  onClear?: () => void;
  mode?: "multiple" | "tags";
  dropdownRender?: (menu: React.ReactElement) => React.ReactElement;
  filterOption?: boolean;
  maxTagCount?: "responsive" | number;
  style?: React.CSSProperties;
}

const DropdownSection: React.FC<DropdownSectionProps> = ({
  label,
  value,
  options,
  placeholder = "Select",
  onChange,
  onClear,
  mode,
  dropdownRender,
  filterOption,
  maxTagCount,
  style,
}) => {
  return (
    <Row gutter={[0, 5]}>
      <Col span={24} className="mt-2 -mb-1.5">
        <Text>{label}</Text>
      </Col>
      <Col span={24} style={style}>
        <Select
          mode={mode}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          onClear={onClear}
          dropdownRender={dropdownRender}
          filterOption={filterOption}
          maxTagCount={maxTagCount}
          allowClear={!!onClear}
          style={{ width: "100%" }}
        >
          {options.map((option) => (
            <Option key={option} value={option}>
              {option}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
  );
};

export default DropdownSection;
